import Vue from 'vue'
import uploader from 'vue-simple-uploader'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import Global from './Global.vue'
import VueCookies from 'vue-cookies'

Vue.prototype.$qs = qs
Vue.prototype.Global = Global
axios.defaults.baseURL=Global.BASE_URL
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAxios, axios)
Vue.use(uploader)
Vue.use(VueCookies)
Vue.$cookies.config('7d')
// Vue.use(router)

new Vue({
  render: h => h(App),
}).$mount('#app')
